var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { DndContext, PointerSensor, KeyboardSensor, useSensor, useSensors, closestCenter, } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, sortableKeyboardCoordinates, } from "@dnd-kit/sortable";
import { EntityRow } from "./EntityRow";
import { SortableEntityRow } from "./SortableEntityRow";
import css from "./EntityRow.module.css";
/** True for values that carry no information and should be omitted. */
var isEmptyValue = function (value) {
    return value == null ||
        value === "" ||
        value === "-" ||
        (typeof value === "string" && value.trim() === "");
};
var FieldsGrid = function (_a) {
    var row = _a.row, columns = _a.columns;
    return (React.createElement("dl", { className: css.fields }, columns.map(function (col) {
        var value = col.cellRenderer(row);
        if (isEmptyValue(value))
            return null;
        return (React.createElement("div", { className: css.field, key: col.name },
            React.createElement("dt", { className: css.fieldLabel }, col.name),
            React.createElement("dd", { className: css.fieldValue }, value)));
    })));
};
/**
 * Uniform compact list for a title form section: renders every data field of
 * each entry as a label → value pair, with always-visible edit/delete actions
 * and optional drag-and-drop reordering. Replaces the wide MultiColumnList
 * tables across the title form sections.
 */
export function EntityRowList(_a) {
    var data = _a.data, columns = _a.columns, renderContent = _a.renderContent, onEdit = _a.onEdit, onDelete = _a.onDelete, canDelete = _a.canDelete, getId = _a.getId, onReorder = _a.onReorder;
    var sortable = !!getId && !!onReorder;
    var sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 8 } }), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates,
    }));
    var rows = data.map(function (row) {
        var _a;
        var common = {
            children: renderContent ? (renderContent(row)) : (React.createElement(FieldsGrid, { row: row, columns: columns !== null && columns !== void 0 ? columns : [] })),
            onEdit: function () { return onEdit(row); },
            onDelete: onDelete ? function () { return onDelete(row); } : undefined,
            canDelete: canDelete ? canDelete(row) : true,
        };
        return sortable ? (React.createElement(SortableEntityRow, __assign({ key: getId(row), id: getId(row) }, common))) : (React.createElement(EntityRow, __assign({ key: (_a = row._rhfId) !== null && _a !== void 0 ? _a : row._index }, common)));
    });
    if (!sortable) {
        return React.createElement("div", { className: css.list }, rows);
    }
    var sortableIds = data.map(function (row) { return getId(row); });
    var handleDragEnd = function (event) {
        var active = event.active, over = event.over;
        if (!over || active.id === over.id)
            return;
        var from = sortableIds.indexOf(String(active.id));
        var to = sortableIds.indexOf(String(over.id));
        if (from !== -1 && to !== -1)
            onReorder(from, to);
    };
    return (React.createElement(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd },
        React.createElement(SortableContext, { items: sortableIds, strategy: verticalListSortingStrategy },
            React.createElement("div", { className: css.list }, rows))));
}
